export const TickCircleIcon = ({ strokeColor = "white", ...props }: any) => (
  <svg {...props} width="22" height="22" viewBox="0 0 22 22" fill="none">
    <g id="vuesax/outline/tick-circle">
      <g id="tick-circle">
        <path
          id="Vector"
          d="M11.0007 20.8538C5.56482 20.8538 1.14648 16.4355 1.14648 10.9997C1.14648 5.56384 5.56482 1.14551 11.0007 1.14551C16.4365 1.14551 20.8548 5.56384 20.8548 10.9997C20.8548 16.4355 16.4365 20.8538 11.0007 20.8538ZM11.0007 2.52051C6.32565 2.52051 2.52148 6.32467 2.52148 10.9997C2.52148 15.6747 6.32565 19.4788 11.0007 19.4788C15.6757 19.4788 19.4798 15.6747 19.4798 10.9997C19.4798 6.32467 15.6757 2.52051 11.0007 2.52051Z"
          fill={strokeColor}
        />
        <path
          id="Vector_2"
          d="M9.6993 14.2821C9.51596 14.2821 9.3418 14.2088 9.21346 14.0805L6.6193 11.4863C6.35346 11.2205 6.35346 10.7805 6.6193 10.5146C6.88513 10.2488 7.32513 10.2488 7.59096 10.5146L9.6993 12.623L14.411 7.91129C14.6768 7.64546 15.1168 7.64546 15.3826 7.91129C15.6485 8.17712 15.6485 8.61712 15.3826 8.88296L10.1851 14.0805C10.0568 14.2088 9.88263 14.2821 9.6993 14.2821Z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);
